import styled from "styled-components";

const Style = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

export default Style;
